import { useEffect } from 'react';

/*  This hook calls the given method when the escape (esc) key is pressed */
export const useCallMethodWhenEscapePressed = (
  methodToCallOnEscape: () => void
): void => {
  useEffect(() => {
    const callOnEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        methodToCallOnEscape();
      }
    };
    window.addEventListener('keydown', callOnEscape);
    return () => window.removeEventListener('keydown', callOnEscape);
  }, [methodToCallOnEscape]);
};
